import { CgSortAz } from 'react-icons/cg';
import CSSortDropdown from './CsFilterDropDown';
import CMButton from '../../components/common/buttons/SimpleButton/CMButton';
import { FaPlus } from "react-icons/fa";
import { IoFilter } from "react-icons/io5";
export default function CSHeader({
  tabType,
  sortOpt,
  setSortOpt,
  handleCreateRequestBlock,
}) {
  return (
    <div className="mt-6 flex justify-between items-center px-2">
      <div>
        <p className="text-coalBlack headingText capitalize">
          {tabType} Consultations
        </p>
      </div>
      <div className="flex items-center gap-2">
        <CMButton 
        className='hidden md:flex lg:flex'
        icon={<FaPlus size={16}  />}
        type='button'
        onClick={handleCreateRequestBlock}
        label={'New Request'}
        />
         
          <CSSortDropdown sortOpt={sortOpt} setSortOpt={setSortOpt} />
        
      </div>
    </div>
  );
}
